
function Home() {
  return (
    <>
        <p>Hello</p>
    </>
  );
}

export default Home;